var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"box"},[_c('h1',{staticClass:"subtitle is-5"},[_vm._v("Aspectos globales")]),_vm._v(" "),_c('h1',{staticClass:"title is-1"},[_vm._v("Nuevo")]),_vm._v(" "),_c('aspectos-form',{on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }